import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobaglorecab() {



    const cardData = {

keyword: "Pune to Bangalore Cab",

headingDescription:
    "Rising Cab Service offers safe, reliable, and comfortable Pune to Bangalore Cab services for families, business travelers, students, and tourists. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for long-distance interstate travel. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, transparent pricing, and smooth highway journeys, ensuring a stress-free travel experience from Pune to Bangalore.",

topPlaces: [
    {
        title: "Lalbagh Botanical Garden",
        description:
            "Lalbagh Botanical Garden is one of Bangalore's most famous attractions, known for its vast collection of rare plants, centuries-old trees, glass house, and beautifully maintained landscapes. It hosts the famous flower shows and is a peaceful escape in the heart of the city."
    },
    {
        title: "Cubbon Park",
        description:
            "Cubbon Park is a large green space in Bangalore offering walking paths, lush gardens, and a calm environment amidst the busy city. It is ideal for morning walks, relaxation, and family outings."
    },
    {
        title: "Bangalore Palace",
        description:
            "Bangalore Palace is a magnificent royal structure inspired by Tudor-style architecture. It features elegant interiors, wooden carvings, and historical artifacts that showcase the royal heritage of Karnataka."
    },
    {
        title: "Bannerghatta National Park",
        description:
            "Bannerghatta National Park is a popular wildlife destination near Bangalore featuring safaris, a zoo, butterfly park, and nature trails. It is home to lions, tigers, elephants, and many other wildlife species."
    },
    {
        title: "ISKCON Temple Bangalore",
        description:
            "ISKCON Temple in Bangalore is a grand spiritual center dedicated to Lord Krishna. Known for its stunning architecture, devotional activities, and peaceful atmosphere, it attracts devotees from all over the world."
    },
    {
        title: "Nandi Hills",
        description:
            "Nandi Hills is a scenic hill station near Bangalore famous for sunrise views, misty landscapes, and trekking trails. It is a favorite weekend getaway for nature lovers and adventure seekers."
    },
    {
        title: "Vidhana Soudha",
        description:
            "Vidhana Soudha is an iconic government building in Bangalore known for its impressive neo-Dravidian architecture and importance as the seat of Karnataka's legislature."
    },
    {
        title: "Commercial Street",
        description:
            "Commercial Street is one of Bangalore's busiest shopping destinations, offering fashion, accessories, street shopping, and a vibrant local market experience."
    },
    {
        title: "Ulsoor Lake",
        description:
            "Ulsoor Lake is one of the largest lakes in Bangalore, offering boating facilities and peaceful surroundings, making it a great place for relaxation and evening walks."
    },
    {
        title: "Wonderla Amusement Park",
        description:
            "Wonderla is a popular amusement park near Bangalore featuring thrilling rides, water attractions, and entertainment zones, making it ideal for families and groups."
    }
],



services: [
{
name: "Pune to Bangalore Cab",
description: "Rising Cab Service offers Pune to Bangalore Cab with safe, comfortable, and affordable long-distance travel for families, business travelers, and tourists. Choose from Sedan, SUV, Innova Crysta, Ertiga, and Tempo Traveller with professional drivers, doorstep pickup, and 24x7 availability for a smooth intercity journey."
},
{
name: "Cab from Pune to Bangalore",
description: "Book Cab from Pune to Bangalore with Rising Cab Service for reliable intercity travel. We provide well-maintained AC vehicles, experienced chauffeurs, transparent pricing, and flexible pickup and drop options for a hassle-free long-distance trip."
},
{
name: "Pune to Bangalore Cab Booking",
description: "Our Pune to Bangalore Cab Booking service offers instant confirmation, multiple vehicle options, and easy online reservation. Enjoy stress-free travel planning with 24x7 customer support and safe transportation across cities."
},
{
name: "Pune to Bangalore Cab Fare",
description: "Get affordable Pune to Bangalore Cab Fare with transparent pricing and no hidden charges. We offer competitive rates for one way, round trip, and customized travel packages based on vehicle type and travel needs."
},
{
name: "Pune to Bangalore Cab Service",
description: "Rising Cab Service provides Pune to Bangalore Cab Service with professional drivers, clean vehicles, and reliable intercity transportation. Ideal for business trips, family travel, and long-distance journeys with complete comfort and safety."
},
{
name: "Pune to Bangalore One Way Cab",
description: "Book Pune to Bangalore One Way Cab for convenient drop-only travel with budget-friendly pricing. Perfect for relocation, business trips, and one-time intercity travel with flexible pickup options."
},
{
name: "Pune to Bangalore Taxi",
description: "Our Pune to Bangalore Taxi service ensures safe, comfortable, and timely travel with experienced drivers and AC vehicles. Choose from multiple cab options for solo, family, or group travel."
},
{
name: "Pune to Bangalore Taxi Fare",
description: "Check Pune to Bangalore Taxi Fare with affordable and transparent pricing. Rising Cab Service offers economical packages for sedan, SUV, and premium vehicles without hidden costs."
},
{
name: "Taxi from Pune to Bangalore",
description: "Rising Cab Service provides Taxi from Pune to Bangalore with reliable chauffeurs, well-maintained cars, and 24x7 booking support for long-distance travel across states."
},
{
name: "Pune to Bangalore Innova Crysta Cab",
description: "Book Pune to Bangalore Innova Crysta Cab for premium comfort, spacious seating, and smooth long-distance travel. Ideal for families and corporate travelers seeking luxury and safety."
},
{
name: "Pune to Bangalore Sedan Cab",
description: "Our Pune to Bangalore Sedan Cab service offers budget-friendly and comfortable travel with clean, fuel-efficient vehicles perfect for solo and small family trips."
},
{
name: "Pune to Bangalore SUV Cab Service",
description: "Rising Cab Service provides Pune to Bangalore SUV Cab Service with spacious seating, AC comfort, and safe long-distance travel for families and groups."
},
{
name: "Pune to Bangalore Car Rental",
description: "Book Pune to Bangalore Car Rental with driver for flexible intercity travel. We offer customized travel plans, multiple vehicle options, and affordable pricing for all types of journeys."
},
{
name: "Pune to Bangalore AC Cab Service",
description: "Our Pune to Bangalore AC Cab Service ensures comfortable travel in all weather conditions with clean, air-conditioned vehicles and professional drivers."
},
{
name: "Pune to Bangalore Round Trip Cab",
description: "Book Pune to Bangalore Round Trip Cab for return journeys with flexible waiting time, comfortable vehicles, and cost-effective travel packages for business and leisure trips."
},
{
name: "Pune to Bangalore Online Cab Booking",
description: "Rising Cab Service offers Pune to Bangalore Online Cab Booking with instant confirmation, secure payments, and easy access to multiple cab options for hassle-free travel."
},
{
name: "Pune to Bangalore Intercity Cab",
description: "Our Pune to Bangalore Intercity Cab service ensures safe, reliable, and comfortable long-distance transportation with experienced drivers and premium vehicles."
},
{
name: "Pune to Bangalore Family Cab Service",
description: "Book Pune to Bangalore Family Cab Service for safe and comfortable group travel with spacious vehicles and professional chauffeurs for long-distance journeys."
},
{
name: "Pune to Bangalore Corporate Cab Service",
description: "Rising Cab Service provides Pune to Bangalore Corporate Cab Service for business travel, employee transportation, and executive trips with punctual and professional service."
},
{
name: "Pune to Bangalore Airport Transfer Cab",
description: "Our Pune to Bangalore Airport Transfer Cab ensures timely pickup and drop for airport travel with reliable drivers and comfortable AC vehicles."
}
],

tableData: [
["Pune to Bangalore Cab","Cab from Pune to Bangalore"],
["Pune to Bangalore Cab Booking","Pune to Bangalore Cab Fare"],
["Pune to Bangalore Cab Service","Pune to Bangalore One Way Cab"],
["Pune to Bangalore Taxi","Pune to Bangalore Taxi Fare"],
["Taxi from Pune to Bangalore","Pune to Bangalore Innova Crysta Cab"],
["Pune to Bangalore Sedan Cab","Pune to Bangalore SUV Cab Service"],
["Pune to Bangalore Round Trip Cab","Pune to Bangalore Online Cab Booking"],
["Pune to Bangalore Intercity Cab","Pune to Bangalore Family Cab Service"],
["Pune to Bangalore Corporate Cab Service","Pune to Bangalore Airport Transfer Cab"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Bangalore Cab Service",
        WhyChoosedescription: "Rising Cab Service offers dependable Pune to Bangalore cab transportation for business professionals, families, students, tourists, and long-distance travelers."
    },
    {
        WhyChooseheading: "Comfortable Interstate Travel Experience",
        WhyChoosedescription: "Travel conveniently between Maharashtra and Karnataka with spacious vehicles, experienced drivers, and flexible travel schedules."
    },
    {
        WhyChooseheading: "Perfect for Corporate and IT Professionals",
        WhyChoosedescription: "Many executives, entrepreneurs, and IT professionals choose our cab service for business meetings, project visits, corporate events, and official travel."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles according to their comfort and group size requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Packages Available",
        WhyChoosedescription: "Whether you need a one-way transfer, return journey, multi-day booking, or customized itinerary, we provide flexible travel solutions."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby areas."
    },
    {
        WhyChooseheading: "Safe Long-Distance Highway Travel",
        WhyChoosedescription: "Our trained drivers are experienced with interstate routes and ensure smooth, safe, and comfortable travel throughout the journey."
    },
    {
        WhyChooseheading: "Customized Travel and Stopover Options",
        WhyChoosedescription: "Passengers can include sightseeing locations, business stops, meal breaks, overnight halts, and multiple city visits according to their itinerary."
    }
]
};

const faqData = [
    {
        question: "Why do travelers frequently visit Bangalore from Pune?",
        answer: "Bangalore is known for its IT industry, business opportunities, educational institutions, startups, technology parks, and tourist attractions."
    },
    {
        question: "Can I book a one-way cab from Pune to Bangalore?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is recommended for Pune to Bangalore travel?",
        answer: "Ertiga, Innova Crysta, SUVs, and Tempo Travellers are preferred for long-distance comfort and luggage space."
    },
    {
        question: "Do corporate travelers use Pune to Bangalore cab services?",
        answer: "Yes, business professionals regularly use our service for meetings, conferences, corporate visits, and project-related travel."
    },
    {
        question: "Can families travel comfortably on this route?",
        answer: "Yes, spacious vehicles with comfortable seating make the journey suitable for families, children, and senior citizens."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for corporate teams, family tours, and group travel."
    },
    {
        question: "Can multiple destinations be included during the trip?",
        answer: "Yes, customized itineraries can include Kolhapur, Belagavi, Hubballi, Davanagere, Mysore, and other destinations along the route."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, passengers can start their journey from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "Is advance booking recommended for Pune to Bangalore travel?",
        answer: "Yes, advance reservations help secure preferred vehicle options and ensure smooth travel planning for long-distance journeys."
    },
    {
        question: "How can I reserve a Pune to Bangalore Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Akash Kulkarni",
        feedback:
            "Traveling to Bangalore for a corporate assignment became extremely convenient with Rising Cab Service. The vehicle was comfortable, and the journey was managed professionally throughout.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaidehi Patwardhan",
        feedback:
            "Our family relocation trip to Bangalore was smooth and stress-free. The cab offered excellent comfort, ample luggage space, and a pleasant travel experience from start to finish.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Bangalore Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-bangalore-cab.jpg",
"description": "Book Pune to Bangalore Cab Service with Rising Cab Service for safe, comfortable, and long-distance interstate travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova Crysta for business and family trips.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-bangalore-cab"
}
};











    return (
        <div>

<Helmet>
  <title>Pune to Bangalore Cab Service | Long Distance Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Bangalore Cab Service for safe and comfortable long-distance travel. Get reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova Crysta cars."
/>

<meta
 name="keywords"
 content="Pune to bangalore cab, Cab from pune to bangalore, Pune to bangalore cab booking, Pune to bangalore cab fare, Pune to bangalore cab service, Pune to bangalore one way cab, Pune to bangalore taxi, Pune to bangalore taxi fare, Taxi from pune to bangalore, Pune to Bangalore Cab, Pune to Bangalore Taxi Service, Pune to Bangalore Cab Booking, Pune to Bangalore One Way Cab, Pune to Bangalore Outstation Cab, Pune to Bangalore Taxi Booking, Pune to Bangalore Innova Crysta Cab, Pune to Bangalore Sedan Cab, Pune to Bangalore SUV Cab Service, Pune to Bangalore Car Rental, Pune to Bangalore AC Cab Service, Pune to Bangalore Round Trip Cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/57.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetobaglorecab;